export const PERMISSION = {
  UNASSIGNED: 'UNASSIGNED',
  ADMIN: 'ADMIN',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
  DENIED: 'DENIED'
}
